import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { productsPageDef } from '@/components/scm/scm-page-defs';

export default function ScmProductsPage() {
  return <ScmPageRenderer pageDef={productsPageDef} />;
}
